// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import { FeatureGateFieldsFragmentDoc } from './features.generated';
import { MinimalOutfitterFieldsFragmentDoc } from './outfitters.generated';
import { EventOrganizerFieldsFragmentDoc } from './event-organizers.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NavigationMenuGroupFieldsFragment = { __typename?: 'NavigationMenuGroup', label?: string | null, items: Array<{ __typename?: 'NavigationMenuItem', label: string, route?: string | null, url: string, icon_feature_key: Types.FeatureIconKey, is_external_link: boolean, feature_status?: Types.FeatureStatus | null, is_paywalled: boolean, gate?: { __typename?: 'FeatureGate', title: string, description: string, cta?: { __typename?: 'Cta', label: string, action: Types.DashboardActionType, value: string } | null, image?: { __typename?: 'ColorModeImage', light: string, dark: string } | null } | null }> };

export type NavigationMenuItemFieldsFragment = { __typename?: 'NavigationMenuItem', label: string, route?: string | null, url: string, icon_feature_key: Types.FeatureIconKey, is_external_link: boolean, feature_status?: Types.FeatureStatus | null, is_paywalled: boolean, gate?: { __typename?: 'FeatureGate', title: string, description: string, cta?: { __typename?: 'Cta', label: string, action: Types.DashboardActionType, value: string } | null, image?: { __typename?: 'ColorModeImage', light: string, dark: string } | null } | null };

export type PortalEntitiesFieldsFragment = { __typename?: 'PortalEntitiesResponse', portal_types: Array<Types.PortalType>, outfitters: Array<{ __typename?: 'Outfitter', id: string, slug: string, name: string, about: string, website?: string | null, primary_contact_email?: string | null, primary_contact_phone?: string | null, is_self_onboarded?: boolean | null, current_self_onboard_step?: Types.SelfOnboardingStepType | null, status: Types.OutfitterStatus, time_zone?: string | null, is_archived: boolean, is_legacy_subscription: boolean, is_free_tier_subscription: boolean, is_processing_fee_payed_by_sportsman?: boolean | null, subscription_tier_name?: string | null, created_at: number, updated_at: number, gmb_id?: string | null, hubspot_company_id?: string | null, featured: boolean, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, stripe_connected_account_id?: string | null }, avatar?: { __typename?: 'Media', url: string } | null, my_roles: Array<{ __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, is_archived: boolean, created_at: number, updated_at: number, user?: { __typename?: 'User', id: string } | null }>, location?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null } | null, photos: Array<{ __typename?: 'Media', url: string }>, feature_access: { __typename?: 'FeatureAccess', features: Array<{ __typename?: 'FeatureAccessSetting', feature_key: Types.FeatureKey, limit?: number | null, current_count?: number | null }> }, enabled_integrations: { __typename?: 'EnabledOutfitterIntegrations', is_quick_books_enabled?: boolean | null, does_quick_books_need_reconnection?: boolean | null, is_meta_enabled?: boolean | null }, badges?: Array<{ __typename?: 'Badge', id: string, name: string, icon_url: string, created_at: number, updated_at: number }> | null, faqs?: Array<{ __typename?: 'FaqItem', id: string, question: string, answer: string }> | null }>, event_organizers: Array<{ __typename?: 'EventOrganizer', id: string, type: Types.EventOrganizerType, name: string, email?: string | null, phone_number?: string | null, bio?: string | null, number_of_organized_events: number, number_of_members: number, current_self_onboard_step: Types.EventOrganizerSelfOnboardingStepType, created_at: number, updated_at: number, documents: Array<{ __typename?: 'Media', url: string, description?: string | null, file_name?: string | null, mime_type?: string | null }>, my_roles: Array<{ __typename?: 'TeamMember', id: string, role: Types.TeamMemberRole }> }> };

export type DashboardNavigationMenuQueryVariables = Types.Exact<{
  portalType: Types.PortalType;
  portalEntityId: Types.Scalars['ID']['input'];
}>;


export type DashboardNavigationMenuQuery = { __typename?: 'Query', dashboardNavigationMenu: Array<{ __typename?: 'NavigationMenuGroup', label?: string | null, items: Array<{ __typename?: 'NavigationMenuItem', label: string, route?: string | null, url: string, icon_feature_key: Types.FeatureIconKey, is_external_link: boolean, feature_status?: Types.FeatureStatus | null, is_paywalled: boolean, gate?: { __typename?: 'FeatureGate', title: string, description: string, cta?: { __typename?: 'Cta', label: string, action: Types.DashboardActionType, value: string } | null, image?: { __typename?: 'ColorModeImage', light: string, dark: string } | null } | null }> }> };

export type PortalEntitiesQueryVariables = Types.Exact<{
  adminSearch?: Types.InputMaybe<Types.PortalEntitiesAdminSearchInput>;
}>;


export type PortalEntitiesQuery = { __typename?: 'Query', portalEntities: { __typename?: 'PortalEntitiesResponse', portal_types: Array<Types.PortalType>, outfitters: Array<{ __typename?: 'Outfitter', id: string, slug: string, name: string, about: string, website?: string | null, primary_contact_email?: string | null, primary_contact_phone?: string | null, is_self_onboarded?: boolean | null, current_self_onboard_step?: Types.SelfOnboardingStepType | null, status: Types.OutfitterStatus, time_zone?: string | null, is_archived: boolean, is_legacy_subscription: boolean, is_free_tier_subscription: boolean, is_processing_fee_payed_by_sportsman?: boolean | null, subscription_tier_name?: string | null, created_at: number, updated_at: number, gmb_id?: string | null, hubspot_company_id?: string | null, featured: boolean, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, stripe_connected_account_id?: string | null }, avatar?: { __typename?: 'Media', url: string } | null, my_roles: Array<{ __typename?: 'TeamMember', id: string, name: string, email: string, role: Types.TeamMemberRole, is_archived: boolean, created_at: number, updated_at: number, user?: { __typename?: 'User', id: string } | null }>, location?: { __typename?: 'Address', street_a?: string | null, city?: string | null, state: string, zip?: string | null, country: string, lat?: number | null, lng?: number | null, note?: string | null } | null, photos: Array<{ __typename?: 'Media', url: string }>, feature_access: { __typename?: 'FeatureAccess', features: Array<{ __typename?: 'FeatureAccessSetting', feature_key: Types.FeatureKey, limit?: number | null, current_count?: number | null }> }, enabled_integrations: { __typename?: 'EnabledOutfitterIntegrations', is_quick_books_enabled?: boolean | null, does_quick_books_need_reconnection?: boolean | null, is_meta_enabled?: boolean | null }, badges?: Array<{ __typename?: 'Badge', id: string, name: string, icon_url: string, created_at: number, updated_at: number }> | null, faqs?: Array<{ __typename?: 'FaqItem', id: string, question: string, answer: string }> | null }>, event_organizers: Array<{ __typename?: 'EventOrganizer', id: string, type: Types.EventOrganizerType, name: string, email?: string | null, phone_number?: string | null, bio?: string | null, number_of_organized_events: number, number_of_members: number, current_self_onboard_step: Types.EventOrganizerSelfOnboardingStepType, created_at: number, updated_at: number, documents: Array<{ __typename?: 'Media', url: string, description?: string | null, file_name?: string | null, mime_type?: string | null }>, my_roles: Array<{ __typename?: 'TeamMember', id: string, role: Types.TeamMemberRole }> }> } };

export type OnboardingTaskActionFieldsFragment = { __typename?: 'OnboardingTaskAction', action: Types.DashboardActionType, label: string, value: string };

export type OnboardingTaskFieldsFragment = { __typename?: 'OnboardingTask', id: string, title: string, description: string, is_complete: boolean, action: { __typename?: 'OnboardingTaskAction', action: Types.DashboardActionType, label: string, value: string } };

export type OnboardingTaskSectionFieldsFragment = { __typename?: 'OnboardingTaskSection', id: string, title: string, description: string, icon_feature_key: Types.FeatureIconKey, progress_percentage: number, tasks: Array<{ __typename?: 'OnboardingTask', id: string, title: string, description: string, is_complete: boolean, action: { __typename?: 'OnboardingTaskAction', action: Types.DashboardActionType, label: string, value: string } }> };

export type OnboardingTasksQueryVariables = Types.Exact<{
  portalType: Types.PortalType;
  portalEntityId: Types.Scalars['ID']['input'];
}>;


export type OnboardingTasksQuery = { __typename?: 'Query', onboardingTasks: Array<{ __typename?: 'OnboardingTaskSection', id: string, title: string, description: string, icon_feature_key: Types.FeatureIconKey, progress_percentage: number, tasks: Array<{ __typename?: 'OnboardingTask', id: string, title: string, description: string, is_complete: boolean, action: { __typename?: 'OnboardingTaskAction', action: Types.DashboardActionType, label: string, value: string } }> }> };

export const NavigationMenuItemFieldsFragmentDoc = gql`
    fragment NavigationMenuItemFields on NavigationMenuItem {
  label
  route
  url
  icon_feature_key
  is_external_link
  feature_status
  is_paywalled
  gate {
    ...FeatureGateFields
  }
}
    ${FeatureGateFieldsFragmentDoc}`;
export const NavigationMenuGroupFieldsFragmentDoc = gql`
    fragment NavigationMenuGroupFields on NavigationMenuGroup {
  label
  items {
    ...NavigationMenuItemFields
  }
}
    ${NavigationMenuItemFieldsFragmentDoc}`;
export const PortalEntitiesFieldsFragmentDoc = gql`
    fragment PortalEntitiesFields on PortalEntitiesResponse {
  portal_types
  outfitters {
    ...MinimalOutfitterFields
  }
  event_organizers {
    ...EventOrganizerFields
  }
}
    ${MinimalOutfitterFieldsFragmentDoc}
${EventOrganizerFieldsFragmentDoc}`;
export const OnboardingTaskActionFieldsFragmentDoc = gql`
    fragment OnboardingTaskActionFields on OnboardingTaskAction {
  action
  label
  value
}
    `;
export const OnboardingTaskFieldsFragmentDoc = gql`
    fragment OnboardingTaskFields on OnboardingTask {
  id
  title
  description
  is_complete
  action {
    ...OnboardingTaskActionFields
  }
}
    ${OnboardingTaskActionFieldsFragmentDoc}`;
export const OnboardingTaskSectionFieldsFragmentDoc = gql`
    fragment OnboardingTaskSectionFields on OnboardingTaskSection {
  id
  title
  description
  icon_feature_key
  progress_percentage
  tasks {
    ...OnboardingTaskFields
  }
}
    ${OnboardingTaskFieldsFragmentDoc}`;
export const DashboardNavigationMenuDocument = gql`
    query dashboardNavigationMenu($portalType: PortalType!, $portalEntityId: ID!) {
  dashboardNavigationMenu(
    portalType: $portalType
    portalEntityId: $portalEntityId
  ) {
    ...NavigationMenuGroupFields
  }
}
    ${NavigationMenuGroupFieldsFragmentDoc}`;

/**
 * __useDashboardNavigationMenuQuery__
 *
 * To run a query within a React component, call `useDashboardNavigationMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardNavigationMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardNavigationMenuQuery({
 *   variables: {
 *      portalType: // value for 'portalType'
 *      portalEntityId: // value for 'portalEntityId'
 *   },
 * });
 */
export function useDashboardNavigationMenuQuery(baseOptions: Apollo.QueryHookOptions<DashboardNavigationMenuQuery, DashboardNavigationMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardNavigationMenuQuery, DashboardNavigationMenuQueryVariables>(DashboardNavigationMenuDocument, options);
      }
export function useDashboardNavigationMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardNavigationMenuQuery, DashboardNavigationMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardNavigationMenuQuery, DashboardNavigationMenuQueryVariables>(DashboardNavigationMenuDocument, options);
        }
export type DashboardNavigationMenuQueryHookResult = ReturnType<typeof useDashboardNavigationMenuQuery>;
export type DashboardNavigationMenuLazyQueryHookResult = ReturnType<typeof useDashboardNavigationMenuLazyQuery>;
export type DashboardNavigationMenuQueryResult = Apollo.QueryResult<DashboardNavigationMenuQuery, DashboardNavigationMenuQueryVariables>;
export const PortalEntitiesDocument = gql`
    query portalEntities($adminSearch: PortalEntitiesAdminSearchInput) {
  portalEntities(adminSearch: $adminSearch) {
    ...PortalEntitiesFields
  }
}
    ${PortalEntitiesFieldsFragmentDoc}`;

/**
 * __usePortalEntitiesQuery__
 *
 * To run a query within a React component, call `usePortalEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalEntitiesQuery({
 *   variables: {
 *      adminSearch: // value for 'adminSearch'
 *   },
 * });
 */
export function usePortalEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<PortalEntitiesQuery, PortalEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalEntitiesQuery, PortalEntitiesQueryVariables>(PortalEntitiesDocument, options);
      }
export function usePortalEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalEntitiesQuery, PortalEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalEntitiesQuery, PortalEntitiesQueryVariables>(PortalEntitiesDocument, options);
        }
export type PortalEntitiesQueryHookResult = ReturnType<typeof usePortalEntitiesQuery>;
export type PortalEntitiesLazyQueryHookResult = ReturnType<typeof usePortalEntitiesLazyQuery>;
export type PortalEntitiesQueryResult = Apollo.QueryResult<PortalEntitiesQuery, PortalEntitiesQueryVariables>;
export const OnboardingTasksDocument = gql`
    query onboardingTasks($portalType: PortalType!, $portalEntityId: ID!) {
  onboardingTasks(portalType: $portalType, portalEntityId: $portalEntityId) {
    ...OnboardingTaskSectionFields
  }
}
    ${OnboardingTaskSectionFieldsFragmentDoc}`;

/**
 * __useOnboardingTasksQuery__
 *
 * To run a query within a React component, call `useOnboardingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingTasksQuery({
 *   variables: {
 *      portalType: // value for 'portalType'
 *      portalEntityId: // value for 'portalEntityId'
 *   },
 * });
 */
export function useOnboardingTasksQuery(baseOptions: Apollo.QueryHookOptions<OnboardingTasksQuery, OnboardingTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingTasksQuery, OnboardingTasksQueryVariables>(OnboardingTasksDocument, options);
      }
export function useOnboardingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingTasksQuery, OnboardingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingTasksQuery, OnboardingTasksQueryVariables>(OnboardingTasksDocument, options);
        }
export type OnboardingTasksQueryHookResult = ReturnType<typeof useOnboardingTasksQuery>;
export type OnboardingTasksLazyQueryHookResult = ReturnType<typeof useOnboardingTasksLazyQuery>;
export type OnboardingTasksQueryResult = Apollo.QueryResult<OnboardingTasksQuery, OnboardingTasksQueryVariables>;